const WIDGET_VERSION_PARAM = 'output_widget_version';

export function versionedWidgetRuntimeUrl(src, version) {
  if (!src || version == null) return src;

  try {
    const url = new URL(src);
    url.searchParams.set(WIDGET_VERSION_PARAM, String(version));
    return url.toString();
  } catch {
    return src;
  }
}
